var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.05 1.83749C10.8872 1.83749 1.83749 10.8872 1.83749 22.05C1.83749 33.2128 10.8872 42.2625 22.05 42.2625C33.2128 42.2625 42.2625 33.2128 42.2625 22.05C42.2625 10.8872 33.2128 1.83749 22.05 1.83749ZM30.8112 18.6322C30.9725 18.4478 31.0953 18.233 31.1724 18.0005C31.2495 17.7679 31.2793 17.5222 31.26 17.278C31.2408 17.0337 31.1729 16.7958 31.0603 16.5782C30.9477 16.3605 30.7928 16.1676 30.6046 16.0108C30.4163 15.8539 30.1986 15.7363 29.9643 15.6648C29.7299 15.5933 29.4836 15.5694 29.2399 15.5945C28.9962 15.6196 28.7599 15.6932 28.5451 15.811C28.3302 15.9288 28.1411 16.0883 27.9888 16.2802L20.0875 25.7599L15.9991 21.6696C15.6525 21.3349 15.1884 21.1497 14.7066 21.1539C14.2248 21.1581 13.764 21.3513 13.4233 21.692C13.0826 22.0327 12.8893 22.4936 12.8851 22.9754C12.881 23.4571 13.0662 23.9213 13.4009 24.2679L18.9134 29.7804C19.0939 29.9608 19.3101 30.1016 19.5481 30.1939C19.7861 30.2862 20.0407 30.3278 20.2957 30.3163C20.5507 30.3047 20.8004 30.2401 21.0291 30.1266C21.2577 30.0132 21.4602 29.8533 21.6237 29.6572L30.8112 18.6322Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e0a87b631f8bd5182d992fc3833a5e27.svg";
export { ForwardRef as ReactComponent };